<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <a-form-model-item ref="templatetype" label="类型" prop="templatetype">
                    <a-select v-if="is_new" v-model="record.templatetype" style="width: 80px">
                        <a-select-option value="1">验证码</a-select-option>
                        <a-select-option value="2">通知短信</a-select-option>
                        <a-select-option value="3">推广短信</a-select-option>
                    </a-select>
                    <span v-else>{{templatetype[record.templatetype]}}</span>
                </a-form-model-item>
<!-- 
                <a-form-model-item ref="templatecode" label="模板编码" prop="templatecode">
                    <a-input v-if="is_vue_task" v-model="record.templatecode" />
                    <span v-else>{{record.templatecode}}</span>
                </a-form-model-item> -->

                <a-form-model-item ref="templatename" label="模板名称" prop="templatename">
                    <a-input v-if="is_vue_task" v-model="record.templatename" />
                    <span v-else>{{record.templatename}}</span>
                </a-form-model-item>

                <a-form-model-item ref="templatetext" label="模板内容" prop="templatetext">
                    <a-input v-if="is_vue_task" v-model="record.templatetext" type="textarea" />
                    <span v-else>{{record.templatetext}}</span>
                </a-form-model-item>

                <a-form-model-item ref="applyorigin" label="平台" prop="applyorigin">
                    <a-input v-if="is_vue_task" v-model="record.applyorigin" />
                    <span v-else>{{record.applyorigin}}</span>
                </a-form-model-item>

                <a-form-model-item ref="remark" label="备注" prop="remark">
                    <a-input v-if="is_vue_task" v-model="record.remark" />
                    <span v-else>{{record.remark}}</span>
                </a-form-model-item>



                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
const templatetype = {
    '1':'验证码',
    '2':'通知短信',
    '3':'推广短信',
}
const m_title = {
    'addtemplatmanager':'新增模板',
    'detailtemplatmanager':'查看模板',
    'edittemplatmanager':'编辑模板',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            templatetype,
            rules: {
                // templatecode: [
                //     { required: true, message: ' 请填写模板编码 ', trigger: 'blur' },
                // ],
                templatename:[
                    { required: true, message: ' 请填写模板名称 ', trigger: 'blur' },

                ],
                templatetext:[
                    { required: true, message: ' 请填写模板内容 ', trigger: 'blur' },
                ],
                applyorigin:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
                templatetype:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                templatetype:'1',
                // templatecode:'',
                templatename:'',
                templatetext:'',
                applyorigin:'',
                remark:'',
            }
        };
    },
    components:{
    },
    methods: {
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'edittemplatmanager'){
                        that.$store
                            .dispatch({
                                type: "wxtemplatemanager/editSmsTemoplateApply",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addtemplatmanager'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "wxtemplatemanager/addSmsTemoplateApply",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(id){
            this.$store.dispatch({
                type: "wxtemplatemanager/querySmsTemplateDetails",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record = {
                        ...result
                    }
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "addtemplatmanager";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detailtemplatmanager'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
